//	ref: https://davidwalsh.name/javascript-debounce-function
/* eslint-disable no-invalid-this, we want to just apply the func in the same context */
const debounce = (func, wait = 300, immediate) => {
	let timeout
	return (...args) => {
		const later = () => {
			timeout = null
			if (!immediate) {
				func.apply(this, args)
			}
		}
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (immediate && !timeout) {
			func.apply(this, args)
		}
	}
}

export default debounce



// WEBPACK FOOTER //
// ./src/utilities/debounce.js